export const loadingCopy = {
  labels: {
    accountSettings: 'Loading account settings...',
    details: 'Loading details...',
    flags: 'Loading flags...',
    metrics: 'Loading metrics...',
    page: 'Loading page...',
    pipelines: 'Loading pipelines...',
    preview: 'Loading preview...',
    projectSettings: 'Loading project settings...',
    suites: 'Loading suites...',
    tags: 'Loading tags...',
    tests: 'Loading tests...',
    workspaceSettings: 'Loading workspace settings...',
  },
} as const;

export type LoadingCopyKey = keyof typeof loadingCopy.labels;

export const getLoadingMessage = (key: LoadingCopyKey): string => loadingCopy.labels[key];

export const getLoadingCopySamples = (): string[] => Object.values(loadingCopy.labels);
